import { forwardRef, FC } from 'react';
import parse, { attributesToProps, DOMNode, domToReact, Element, HTMLReactParserOptions } from 'html-react-parser';
import domPurify from 'dompurify';
import { useShouldOpenInNewTab } from '../../lib/useShouldOpenInNewTab';
import { OpenInNewTabIcon } from '../Icons/OpenInNewTabIcon';

const AnchorWithTarget = forwardRef<HTMLAnchorElement>((props, ref) => {
  const { children, ...otherProps } = props as any;

  const shouldOpenInNewTab = useShouldOpenInNewTab();

  let linkProps: object = {
    target: '_parent'
  };
  let icon: React.ReactNode;

  if (shouldOpenInNewTab) {
    // Open in new window
    linkProps = {
      target: '_blank',
      rel: 'noopener noreferrer'
    };
    icon = <OpenInNewTabIcon />;
  }

  // eslint-disable-next-line jsx-a11y/anchor-has-content
  return (
    <a {...linkProps} {...otherProps} ref={ref}>
      {children}
      {icon}
    </a>
  );
});

const options: HTMLReactParserOptions = {
  replace(domNode) {
    if (domNode instanceof Element && domNode.name === 'a') {
      const { attribs, children } = domNode;
      const props = attributesToProps(attribs);
      return <AnchorWithTarget {...props}>{domToReact(children as DOMNode[], options)}</AnchorWithTarget>;
    }

    return domNode;
  }
};

export const ParseHTML: FC<{ content?: string }> = ({ content = '' }) => {
  return <>{parse(domPurify.sanitize(content), options)}</>;
};

ParseHTML.displayName = 'ParseHTML';
